import { OverlayModule } from '@angular/cdk/overlay';

import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  input,
  output,
  signal,
} from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { v4 as uuidv4 } from 'uuid';

import { DealFilterMode } from '../../../deal-filter/models/deal-filter.model';
import { HelpIconComponent } from '../../../help/components/help-icon/help-icon.component';
import { Transaction } from '../../../home/models/transaction.model';
import { ButtonDirective } from '../../../ui/button/button/button.directive';
import { IconButtonDirective } from '../../../ui/button/icon-button/icon-button.directive';
import { SemerisRoutes } from '../../constants/routes';
import { FastTooltipDirective } from '../../directives/fast-tooltip.directive';
import { IfAssetDirective } from '../../directives/if-asset.directive';
import { ItemCartTargetDirective } from '../../directives/item-cart-target.directive';
import { PermissionsDirective } from '../../directives/permissions.directive';
import { Permission } from '../../models/api/permissions.enum';
import { PanelAction, PanelCommand } from '../../models/common/command';
import { IPanelComponent } from '../../models/common/i-panel.component';
import { ColumnsToLinkPipe } from '../../pipes/columns-to-link.pipe';
import { LabelsComponent } from '../labels/labels.component';
import { LatestIssuanceComponent } from '../latest-issuance/latest-issuance.component';
import { TrafficLightComponent } from '../traffic-light/traffic-light.component';
import { TransactionToLinkPipe } from '../../pipes/transaction-to-link.pipe';

@Component({
  imports: [
    OverlayModule,
    MatIconModule,
    MatBadgeModule,
    MatDividerModule,
    RouterModule,
    TrafficLightComponent,
    LatestIssuanceComponent,
    ItemCartTargetDirective,
    IfAssetDirective,
    ColumnsToLinkPipe,
    HelpIconComponent,
    LabelsComponent,
    PermissionsDirective,
    IconButtonDirective,
    ButtonDirective,
    FastTooltipDirective,
    TransactionToLinkPipe
],
  selector: 'semeris-deals-indicator',
  templateUrl: './deals-indicator.component.html',
  styleUrls: ['./deals-indicator.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealsIndicatorComponent implements IPanelComponent {
  readonly deals = input<Transaction[]>(undefined);
  readonly loading = input<boolean>(undefined);

  readonly remove = output<string>();
  readonly clear = output();

  readonly addExamples = output();

  public isOpen = signal<boolean>(false);
  public readonly SemerisRoutes = SemerisRoutes;
  public readonly Permission = Permission;
  public readonly dealFilterMode = DealFilterMode.BasketOnly;

  public handleCommand(command: PanelAction) {
    if (command.command === PanelCommand.Open) {
      this.isOpen.set(true);
    }
  }

  public toggle() {
    this.isOpen.update((prev) => !prev);
  }

  public get displayName() {
    const id = uuidv4();
    return `Selected deals ${id.substr(id.length - 6)}`;
  }

  public get transactionNames(): string {
    return this.deals()
      .map((d) => d.transactionId)
      .join(',');
  }

  public onRemoveFromSelection(id: string, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.remove.emit(id);
  }

  public onClear() {
    this.clear.emit();
  }

  public addExample() {
    this.addExamples.emit();
  }
}
